// src/reportWebVitals.ts
import { Metric, getCLS, getFID, getFCP, getLCP, getTTFB } from 'web-vitals'; // Metric をインポート

const reportWebVitals = (onPerfEntry?: (metric: Metric) => void): void => { // onPerfEntry の型を修正
  if (onPerfEntry && typeof onPerfEntry === 'function') {
    // import は一度インポートしていれば通常は不要ですが、念のため残します
    // ただし、既にトップレベルでインポートしているので、これは冗長です
    // 静的インポートに一本化することをお勧めします
    // import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
    getCLS(onPerfEntry);
    getFID(onPerfEntry);
    getFCP(onPerfEntry);
    getLCP(onPerfEntry);
    getTTFB(onPerfEntry);
    // });
  }
};

export default reportWebVitals;